import { Component,OnInit } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import {} from '@angular/router';
import { APP_CONST } from 'src/app/shared/constants/app-constants';
@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
  statusCode:string='404';
  constructor(private router:Router,private route:ActivatedRoute){}
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const  code = params['status'];
      if(code){
        this.statusCode = code
      }
    });
  }
  goToHome(){
    
    this.router.navigate([APP_CONST.ROUTE_ACCOUNTS])
  }
}
